import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ConfigService {

    constructor(private http: HttpClient) {}

    public load(): Observable<any> {

        // default config name, that is used if env variable is not given
        let configName = 'config';

        // use config name from env variable if present
        if (process.env.SSF_CONFIG_ENV) {
            configName += `_${process.env.SSF_CONFIG_ENV}`;
        }

        return this.http.get<object>(`configuration/${configName}.json`);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/config/config.service.ts